import { Link } from 'react-router-dom'
import { Button } from '@/components/ui/button'
import { GlassCard } from '@/components/ui/glass-card'
import { useLuxeHero, useLuxeGrid } from '@gjl/motion/css'
import { ArrowRight, ShieldCheck, ClipboardList, FileBarChart2 } from 'lucide-react'

const cards = [
  {
    icon: ShieldCheck,
    title: 'Five questions to ask any operator',
    description:
      "How to vet anyone you're considering investing with — including us. Each question with what good looks like and how Fairmeadow answers.",
    href: '/operator-questions',
    cta: 'Read the questions',
  },
  {
    icon: ClipboardList,
    title: 'Are we a fit for each other?',
    description:
      'Eight-question assessment covering capital range, time horizon, liquidity, and operator alignment. Submit to hear from Garrett within 1 – 2 business days.',
    href: '/fit',
    cta: 'Take the assessment',
  },
  {
    icon: FileBarChart2,
    title: 'See the Track Record',
    description:
      'Every closed deal with full financials — purchase, financing, rent roll, occupancy. Public, not gated behind an investor portal.',
    href: '/track-record',
    cta: 'View the portfolio',
  },
]

export default function ForInvestorsPage() {
  const heroRef = useLuxeHero<HTMLDivElement>(0.2)
  const gridRef = useLuxeGrid<HTMLDivElement>('.for-investors-card')

  return (
    <div className="bg-background text-foreground">
      <section className="relative overflow-hidden py-24 md:py-32">
        <div className="bg-gradient-dark-gold absolute inset-0" />
        <div ref={heroRef} className="relative z-10 mx-auto max-w-4xl px-4 text-center">
          <p className="text-primary mb-6 text-lg font-medium tracking-wide">For investors</p>
          <h1 className="text-fluid-h1 text-foreground mb-6">Vet us before you wire a dollar.</h1>
          <p className="text-fluid-body-lg text-muted-foreground mx-auto max-w-2xl">
            We'd rather lose your interest now than mismatch on horizon, liquidity, or expectations later. Three places
            to start.
          </p>
        </div>
      </section>

      <section ref={gridRef} className="px-4 py-16 md:py-24">
        <div className="mx-auto grid max-w-5xl gap-6 md:grid-cols-3">
          {cards.map((card) => {
            const Icon = card.icon
            return (
              <GlassCard key={card.href} hover className="for-investors-card flex h-full flex-col">
                <div className="bg-primary/10 mb-4 flex h-12 w-12 items-center justify-center rounded-xl">
                  <Icon className="text-primary h-6 w-6" />
                </div>
                <h2 className="text-foreground mb-3 text-xl font-semibold">{card.title}</h2>
                <p className="text-muted-foreground mb-6 flex-1">{card.description}</p>
                <Link to={card.href}>
                  <Button variant="outline-gold" className="w-full">
                    {card.cta}
                    <ArrowRight className="ml-2 h-4 w-4" />
                  </Button>
                </Link>
              </GlassCard>
            )
          })}
        </div>
      </section>
    </div>
  )
}
